import 'grapesjs/dist/css/grapes.min.css';
import HospitalSelector, { HospitalSelectorNodeType, hospitalSelectorType } from '../admin/hospitalSelector';
import { useEffect, useState } from 'react';
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import CommonService from '@/defines/service/commonService';
import { fetchQuery, graphql, useMutation } from 'react-relay';
import type { requestCareDetailInsertMutation as InsertMutation } from './__generated__/requestCareDetailInsertMutation.graphql'
import type { requestCareDetailUpdateMutation as UpdateMutation } from './__generated__/requestCareDetailUpdateMutation.graphql'
import type { requestCareDetailQuery$data as DetailQueryType } from './__generated__/requestCareDetailQuery.graphql'
import { RelayEnvironment } from '@/RelayEnvironment';
import { useUserStore } from '@/defines/store/userStore';
import moment from 'moment';
import AlertService from "@/defines/service/alertService"
import { RequestStatus, RequestType } from '@/defines/requestDefines';
import { useNavigate } from 'react-router-dom';
import InsuranceService from '@/defines/service/insuranceService';


interface MedicalCenterAnesthesiologists {
    medical_center: {
        id: number;
        name: string;
    }
}

interface Care {
    aiconsultdetailid: number | null | undefined;
    caredetailid: number | null | undefined;
    created_at: any | null | undefined;
    id: string;
    insuranceid: string;
    recipient: {
        email: string | null | undefined;
        id: string;
        imageurl: string | null | undefined;
        last_seen: any;
        name: string;
    } | null | undefined;
    recipientid: string | null | undefined;
    request_care_details: CareDetail | null | undefined;
    requeststatus: number;
    requesttype: number;
}

interface CareDetail {
    addressdetail: string | null | undefined;
    created_at: any;
    desiredenddate: Date;
    desiredstartdate: Date;
    excutedate: any | null | undefined;
    excuterid: string | null | undefined;
    hospitalid: number | null | undefined;
    id: string;
    otherrequirement: string | null | undefined;
    patientname: string;
}

const RequestCareDetailQuery = graphql`
query requestCareDetailQuery($id: Int!, $insuranceid: String!){
  insurance_request_log_connection(where: {id: {_eq: $id}, insuranceid: {_eq: $insuranceid}}) {
    edges {
      node {
        request_care_details {
          id
          otherrequirement
          patientname
          hospitalid
          excuterid
          excutedate
          desiredstartdate
          desiredenddate
          created_at
          addressdetail
          hospital {
            id
            images
            name
          }
        }
        recipient {
          id
          email
          imageurl
          last_seen
          name
        }
        requeststatus
        requesttype
        recipientid
        insuranceid
        id
        created_at
        caredetailid
        aiconsultdetailid
      }
    }
  }
}
`

const RequestCareDetailInsertMutation = graphql`
mutation requestCareDetailInsertMutation(
    $insuranceid: String!
    $requesttype: Int!
    $requeststatus: Int!
    $recipientid: String
    $hospitalid: Int!
    $patientname: String!
    $otherrequirement: String!
    $desiredstartdate: timestamptz!
    $desiredenddate: timestamptz!
    $addressdetail: String!
  ) {
    insert_insurance_request_log_one(
        object: {
            insuranceid: $insuranceid
            requesttype: $requesttype
            requeststatus: $requeststatus
            recipientid: $recipientid
            request_care_details: {
                data: {
                    hospitalid: $hospitalid
                    patientname: $patientname
                    otherrequirement: $otherrequirement
                    desiredstartdate: $desiredstartdate
                    desiredenddate: $desiredenddate
                    addressdetail: $addressdetail
                }
            }
        }
    ) {
        id
        request_care_details {
            id
        }
    }
  }
`

const RequestCareDetailUpdateMutation = graphql`
mutation requestCareDetailUpdateMutation(
    $recipientid: String
    $id: Int!
    $caredetailid: Int!
    $requeststatus: Int!
    $hospitalid: Int!
    $patientname: String!
    $otherrequirement: String!
    $desiredstartdate: timestamptz!
    $desiredenddate: timestamptz!
    $addressdetail: String!
  ) {
    update_insurance_request_log(
        where: {id: {_eq: $id}}, 
        _set: {
            recipientid: $recipientid, 
            requeststatus: $requeststatus
        }
    ) {
        affected_rows
    }

    update_request_care_detail(
        where: {id: {_eq: $caredetailid}}, 
        _set: {
            hospitalid: $hospitalid
            patientname: $patientname
            otherrequirement: $otherrequirement
            desiredstartdate: $desiredstartdate
            desiredenddate: $desiredenddate
            addressdetail: $addressdetail
        }) {
        affected_rows
    }
  }
`

export default function RequestCareDetail() {
    const alertService = AlertService();
    const [data, setData] = useState({} as Care);
    const [detailData, setDetailData] = useState({} as CareDetail);
    const [openHospitalSelector, setOpenHospitalSelector] = useState(false);
    const [careHospitals, setCareHospitals] = useState({} as MedicalCenterAnesthesiologists);
    const [commitInsert] = useMutation<InsertMutation>(RequestCareDetailInsertMutation);
    const [commitUpdate] = useMutation<UpdateMutation>(RequestCareDetailUpdateMutation);
    const userId = useUserStore.getState().userData.id;
    const navigate = useNavigate();
    const [sending, setSending] = useState(false);

    const search = window.location.search
    const params = new URLSearchParams(search)

    const fetchData = async (id: string) => {
        if (id) {
            const detailRes = await fetchQuery(RelayEnvironment, RequestCareDetailQuery, {
                insuranceid: userId,
                id: CommonService().DecodeNodeId(id),
            }).toPromise();

            let detailData = (detailRes as DetailQueryType).insurance_request_log_connection.edges[0].node;
            var forSetData = {} as Care;

            if (detailData.recipient) {
                forSetData.recipient = {
                    email: detailData.recipient.email,
                    id: detailData.recipient.id,
                    imageurl: detailData.recipient.imageurl,
                    last_seen: detailData.recipient.last_seen,
                    name: detailData.recipient.name,
                }
            }
            if (detailData.request_care_details) {
                forSetData.request_care_details = {
                    addressdetail: detailData.request_care_details.addressdetail,
                    created_at: detailData.request_care_details.created_at,
                    desiredenddate: new Date(detailData.request_care_details.desiredenddate),
                    desiredstartdate: new Date(detailData.request_care_details.desiredstartdate),
                    excutedate: detailData.request_care_details.excutedate,
                    excuterid: detailData.request_care_details.excuterid,
                    hospitalid: detailData.request_care_details.hospitalid,
                    id: detailData.request_care_details.id,
                    otherrequirement: detailData.request_care_details.otherrequirement,
                    patientname: detailData.request_care_details.patientname,
                }
                setDetailData(forSetData.request_care_details);
            }
            forSetData.aiconsultdetailid = detailData.aiconsultdetailid;
            forSetData.caredetailid = detailData.caredetailid;
            forSetData.created_at = detailData.created_at;
            forSetData.id = detailData.id;
            forSetData.insuranceid = detailData.insuranceid;
            forSetData.recipientid = detailData.recipientid;
            forSetData.request_care_details = detailData.request_care_details;
            forSetData.requeststatus = detailData.requeststatus;
            forSetData.requesttype = detailData.requesttype;
            setData(forSetData);

            if (detailData.request_care_details?.hospital) {
                var selectedData = {} as MedicalCenterAnesthesiologists;
                selectedData.medical_center = {
                    id: CommonService().DecodeNodeId(detailData.request_care_details?.hospital.id),
                    name: detailData.request_care_details?.hospital.name ?? ''
                };
                setCareHospitals(selectedData);
            }
        }
        else {
            setData({ ...data, insuranceid: userId })
            setData({ ...data, requeststatus: RequestStatus.init })
            setData({ ...data, requesttype: RequestType.care })
        }
    }

    useEffect(() => {
        const id = params.get('id')
        if(id){
            fetchData(id);
        }
    }, [])

    const confirmSelectHospital = async (selected: HospitalSelectorNodeType) => {
        console.log(selected);
        setOpenHospitalSelector(false);

        setDetailData({ ...detailData, hospitalid: CommonService().DecodeNodeId(selected.id) });

        var selectedData = {} as MedicalCenterAnesthesiologists;
        selectedData.medical_center = { id: CommonService().DecodeNodeId(selected.id), name: selected.name ?? '' };
        setOpenHospitalSelector(false);
        setCareHospitals(selectedData);
    }

    const submit = () => {
        var dateMinimum = new Date();
        dateMinimum = new Date(dateMinimum.setDate(dateMinimum.getDate() + 1));
        if (!detailData.desiredstartdate || !detailData.desiredenddate) {
            alertService.Error('請填寫時間 ! ');
            return;
        }
        if (detailData.desiredstartdate < dateMinimum) {
            alertService.Error('請填寫明天以後的時間 ! ');
            return;
        }
        const diffInMilliseconds = (detailData.desiredenddate.getTime() - detailData.desiredstartdate.getTime());
        const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
        console.log(diffInMilliseconds);
        console.log(diffInDays);
        if (diffInDays < 3) {
            alertService.Error('時間不足三天 ! ');
            return;
        }
        setSending(true);
        console.log('data', data);
        console.log('detailData', detailData);
        InsuranceService().InitData(userId);
        if (data.id) {
            commitUpdate({
                variables: {
                    recipientid: data.recipientid,
                    id: CommonService().DecodeNodeId(data.id),
                    requeststatus: data.requeststatus,
                    caredetailid: CommonService().DecodeNodeId(detailData.id),
                    hospitalid: detailData.hospitalid ?? 0,
                    patientname: detailData.patientname,
                    otherrequirement: detailData.otherrequirement ?? '',
                    desiredstartdate: detailData.desiredstartdate,
                    desiredenddate: detailData.desiredenddate,
                    addressdetail: detailData.addressdetail ?? '',
                },
                onCompleted: () => {
                    console.log('onCompleted');
                    alertService.Info('更新成功 ! ');
                    setSending(false);
                },
                onError: (error) => {
                    console.error('Error updating user', error);
                    alertService.Error('更新失敗 ! 請檢察是否有內容未填寫 ! ');
                    setSending(false);
                }
            });
        }
        // insert
        else {
            commitInsert({
                variables: {
                    insuranceid: userId,
                    requesttype: RequestType.care,
                    requeststatus: RequestStatus.init,
                    recipientid: data.recipientid,
                    hospitalid: detailData.hospitalid ?? 0,
                    patientname: detailData.patientname,
                    otherrequirement: detailData.otherrequirement ?? '',
                    desiredstartdate: detailData.desiredstartdate,
                    desiredenddate: detailData.desiredenddate,
                    addressdetail: detailData.addressdetail ?? '',
                },
                onCompleted: (response) => {
                    console.log('onCompleted', response);
                    navigate('/insurance/request-care/detail?id=' + response.insert_insurance_request_log_one?.id);
                    alertService.Info('新增成功 ! ');
                    setSending(false);
                    fetchData(response.insert_insurance_request_log_one!.id);
                },
                onError: (error) => {
                    setSending(false);
                    alertService.Error('新增失敗 ! 請檢察是否有內容未填寫 ! ');
                    console.error('Error updating user', error);
                }
            });
        }
    }

    return (
        <>
            <div className="mx-auto w-full" style={{ "maxWidth": "1400px" }}>
                <div className="mt-10 grid sm:grid-cols-6 grid-cols-1 gap-x-6 gap-y-8 mx-4" >

                    <h1 className="sm:col-span-6 text-3xl font-bold text-gray-900 sm:text-4xl">關懷詳細資料</h1>

                    <div className="sm:col-span-3">
                        <label className="block text-sm font-medium leading-6 text-gray-900">
                            需關懷客戶姓名
                        </label>
                        <div className="mt-2">
                            <input
                                type="text"
                                autoComplete="name"
                                value={detailData.patientname || ''} onChange={(e) => setDetailData({ ...detailData, patientname: e.target.value })}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-red-400 sm:text-sm sm:leading-6"
                            />
                        </div>
                    </div>
                    <div className="sm:col-span-3">
                        <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                            關懷時間區間(至少三日)
                        </label>
                        <div className="mt-2 flex">

                            <DateTimePicker
                                value={detailData.desiredstartdate}
                                onChange={(date) => {
                                    // console.log(date);
                                    const formattedDate = new Date(moment(date).format('YYYY-MM-DDTHH:mm:ss.SSSSSS[+00:00]'));
                                    setDetailData({ ...detailData, desiredstartdate: formattedDate })
                                }}
                                format='y/MM/dd'
                                className="h-8 w-full mx-1"
                            />
                            <DateTimePicker
                                value={detailData.desiredenddate}
                                onChange={(date) => {
                                    // console.log(date);
                                    const formattedDate = new Date(moment(date).format('YYYY-MM-DDTHH:mm:ss.SSSSSS[+00:00]'));
                                    setDetailData({ ...detailData, desiredenddate: formattedDate })
                                }}
                                format='y/MM/dd'
                                className="h-8 w-full mx-1"
                            />

                        </div>
                    </div>

                    <div className="sm:col-span-3">
                        <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                            客戶所在醫院

                            <button
                                type="button"
                                onClick={() => setOpenHospitalSelector(true)}
                                className="inline-flex items-center gap-x-1.5 rounded-md bg-red-400 ml-2 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-red-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-400"
                            >
                                選擇
                            </button>
                        </label>

                        <HospitalSelector openModal={openHospitalSelector} confirmHospital={confirmSelectHospital} type={hospitalSelectorType.InsuranceAgent} closeModal={() => setOpenHospitalSelector(false)}></HospitalSelector>
                        <div className="mt-2">
                            <span className="inline-flex items-center gap-x-0.5 rounded-md bg-gray-100 px-2 py-1 m-2 text-base font-medium ">
                                {careHospitals?.medical_center?.name}
                            </span>
                        </div>
                    </div>

                    <div className="sm:col-span-3">
                        <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
                            客戶詳細資料(樓層、病房號等等)
                        </label>
                        <div className="mt-2">
                            <input
                                id="detailAddress"
                                name="detailAddress"
                                type="text"
                                value={detailData.addressdetail ?? ""}
                                onChange={(e) => setDetailData({ ...detailData, addressdetail: e.target.value })}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-red-400 sm:text-sm sm:leading-6"
                            />
                        </div>
                    </div>

                    <div className="sm:col-span-6">
                        <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
                            其他期望需求
                        </label>
                        <div className="mt-2">
                            <textarea
                                id="otherRequirement"
                                name="otherRequirement"
                                value={detailData.otherrequirement ?? ""}
                                onChange={(e) => setDetailData({ ...detailData, otherrequirement: e.target.value })}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-red-400 sm:text-sm sm:leading-6"
                            />
                        </div>
                    </div>


                    <div className="sm:col-span-6 flex flex-row-reverse">
                        <button
                            type="button"
                            disabled={sending}
                            onClick={() => { submit() }}
                            className="rounded-md bg-red-400 mx-1 px-3.5 py-2.5 text-base font-semibold text-white shadow-sm hover:bg-red-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-400"
                        >
                            送出
                        </button>
                        <button
                            type="button"
                            disabled={sending}
                            onClick={() => { navigate('/insurance/request-care') }}
                            className="rounded-md mx-1 px-3.5 py-2.5 text-base font-semibold text-red-400 shadow-sm outline outline-2 outline-red-400"
                        >
                            回列表
                        </button>
                    </div>

                </div>
            </div>
        </>
    )
}